@if (breadcrumbs$ | async; as breadcrumbs) {
  @if (breadcrumbs?.length) {
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a sRouterLink="home">{{ 'Home' | translate | async }}</a>
        </li>
        @for (breadcrumb of breadcrumbs; track breadcrumb) {
          <li class="breadcrumb-item">
            <a [sRouterLink]="breadcrumb.url">
              {{ breadcrumb.label | translate | async }}
            </a>
          </li>
        }
      </ol>
    </nav>
  }
}
